import { Link } from "react-router";
import { Image } from "lucide-react";
import type { Machine, MachineFamily } from "../../api/catalogue";
import { Button, Select } from "../ui";

export interface MachinePickerProps {
  families: MachineFamily[];
  familyId: number;
  machineId: number;
  /** The chosen machine's plates; undefined while they load. */
  machine: Machine | undefined;
  assemblyId: number | null;
  onFamily: (id: number) => void;
  onMachine: (id: number) => void;
  onAssembly: (id: number) => void;
  onOpen: () => void;
}

/** Family, machine, assembly: three choices to the right diagram (desktop kit MachinePicker). */
export function MachinePicker({ families, familyId, machineId, machine, assemblyId, onFamily, onMachine, onAssembly, onOpen }: MachinePickerProps) {
  const family = families.find((f) => f.id === familyId) ?? families[0];
  const plates = machine?.assemblies ?? [];
  return (
    <div>
      <div className="grid gap-4 sm:grid-cols-3">
        <Select
          label="Machine type"
          size="lg"
          value={String(familyId)}
          onChange={(event) => onFamily(Number(event.target.value))}
          options={families.map((f) => ({ value: String(f.id), label: f.name }))}
        />
        <Select
          label="Model"
          size="lg"
          value={String(machineId)}
          onChange={(event) => onMachine(Number(event.target.value))}
          options={family.equipment_models.map((m) => ({ value: String(m.id), label: m.name }))}
        />
        <Select
          label="Assembly"
          size="lg"
          disabled={!machine}
          value={assemblyId === null ? "" : String(assemblyId)}
          onChange={(event) => onAssembly(Number(event.target.value))}
          options={machine ? plates.map((a) => ({ value: String(a.id), label: a.name })) : [{ value: "", label: "Loading…" }]}
        />
      </div>
      <Button size="lg" icon={Image} className="mt-5 w-full sm:w-auto" disabled={assemblyId === null} onClick={onOpen}>
        Open the diagram
      </Button>
      {plates.length > 1 && (
        <div className="mt-5 flex flex-wrap gap-2">
          {plates.map((plate) => (
            <Link
              key={plate.id}
              to={`/assemblies/${plate.id}`}
              className="inline-flex min-h-9 max-md:min-h-11 items-center rounded-full border border-border-default bg-surface-card px-3 type-small text-text-body hover:border-green-700 hover:text-green-800"
            >
              {plate.name}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
